// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z4G3","content":"styles_content__3T1W_","tableWrap":"styles_tableWrap__WbPch"};